const commonAndMisc = {
  provideImportantInfoForYourTravel: "Let us know of any information that would be important during your travel", // translated
  errorMessage404: "אופס! הדף שאתה מחפש אינו קיים", // translated
  errorContentUnavailable: "אופס! התוכן שאתה מחפש אינו קיים. אנא צור איתנו קשר לגבי הבעיה", // translated
  backToHome: "בחזרה לבית", // translated
  information: "מֵידָע", // translated
  additionalInformation: "מידע נוסף", // translated
  destinationPlaceholder: "לאן אתה הולך", // translated
  aboutUs: "עלינו", // translated
  pleaseWait: "המתן בבקשה...", // translated
  featuredHotels: "מלונות מומלצים", // translated
  topPackages: "חבילות מובילות", // translated
  topTours: "סיורים מובילים", // translated
  traveller: "נוֹסֵעַ", // translated
  reviews: "ביקורות", // translated
  home: "בית", // translated
  packages: "חבילות", // translated
  experiences: "חוויות", // translated
  close: "סגור", // translated
  loadingMessage: "אנא המתן בזמן שאנו מחפשים את המחירים הטובים ביותר הזמינים", // translated
  loadingMessageTheHotelCo: "אנא המתן בזמן שאנו מחפשים את המחירים הטובים ביותר הזמינים", // translated
  loadingMessageSearchStrip: "אנא המתן בזמן שאנו מחפשים את המחירים הטובים ביותר הזמינים...", // translated

  stillSearchingHotels:
    "Still searching — {{priced}} of {{discovered}} hotels priced",
  hotelsProgressCount: "Found {{priced}} of {{discovered}} hotels",
  searchingSuppliers: "Checking {{suppliers}}",
  topCountriesToVisit: "מדינות מובילות לביקור", // translated
  profile: "פּרוֹפִיל", // translated
  reservations: "הזמנות", // translated
  address: "כתובת", // translated
  firstName: "שם פרטי", // translated
  lastName: "שם משפחה", // translated
  email: "אימייל", // translated
  login: "התחברות", // translated
  logout: "להתנתק", // translated
  myProfile: "הפרופיל שלי", // translated
  myChatRooms: "הצ'אטים שלי", // translated 
  chatRoomsListEmpty: "אין לך חדרי צ'אט עבור חשבון זה.", // translated 
  chatRoomsOpen: "לִפְתוֹחַ", // translated 
  chatRoomsLastActivity: "פעילות אחרונה", // translated 
  chatRoomsUnread: "לא נקרא", // translated 
  chatRoomsBadgeQuotation: "הצעת מחיר", // translated 
  chatRoomsBadgeTripOffer: "הצעת טיול", // translated 
  chatRoomsOpenQuotationAria: "פתח צ'אט הצעת מחיר: {{name}}", // translated 
  chatRoomsOpenTripOfferAria: "פתח צ'אט של הצעות טיול: {{name}}", // translated 
  chatRoomsOpenGenericAria: "פתח צ'אט: {{name}}", // translated 
  quotationChatInvalidLink:
    "קישור צ'אט לא חוקי. פתח צ'אט מהפרופיל או מרשימת הצעות מחיר, או השתמש ב-room_code או room_uid בלבד.", // translated 
  quotationChatNoTripDetails: "פרטי הנסיעה לא זמינים לצ'אט זה.", // translated 
  chat: "לְשׂוֹחֵחַ", // translated 
  verified: "מְאוּמָת", // translated
  unverified: "לא מאומת", // translated
  selectLanguage: "בחר שפה", // translated
  selectCurrency: "תבחר מדינה", // translated
  upgrade: "שדרוג", // translated
  membership: "חֲבֵרוּת", // translated
  travelTrust: "אמון נסיעות", // translated
  signInUp: "היכנס/ירשם", // translated
  worldwideHotelsAndResortsAtAmazingWholesaleRates: "מלונות ואתרי נופש ברחבי העולם בתעריפים סיטונאיים מדהימים", // translated
  dashboard: "לוּחַ מַחווָנִים", // translated
  pricing: "תמחור", // translated
  refundable: "ניתן להחזר", // translated
  cars: "מכוניות", // translated
  cruises: "הפלגות", // translated
  view: "נוף", // translated
  price: "מחיר", // translated // translated 
  totalPrice: "מחיר סופי", // translated
  filterRoomName: "שם חדר סינון", // translated
  get: "לקבל", // translated
  guestInformationValidation: "אימות מידע אורח", // translated
  reservation: "הזמנה", // translated
  checkIn: "קבלה", // translated
  checkOut: "לבדוק", // translated
  paymentInitiattionErroeMessage: "לא הצלחנו להתחיל את תהליך התשלום שלך. אנו מצטערים על אי הנוחות", // translated
  warning: "אַזהָרָה", // translated
  couldNotFindPriceForDateWarning: "לא מצאנו מחיר לתאריך זה. אנא נסה שוב לתאריך אחר", // translated
  searchFormValidationError: "שגיאת אימות טופס חיפוש", // translated
  pleaseSelectValidDateFirst: "אנא בחר תחילה תאריך חוקי", // translated
  searchError: "שגיאת חיפוש", // translated
  priceSearchInitiationError: "לא יכולנו להתחיל את תהליך חיפוש המחירים. בבקשה נסה שוב מאוחר יותר. אנו מצטערים על אי הנוחות", // translated
  searchWarning: "אזהרת חיפוש", // translated
  couldNotFindPriceAndOrAvailability: "לא הצלחנו למצוא מחיר ו/או זמינות עבור בקשתך. אנו מצטערים על אי הנוחות", // translated
  joinNow: "הצטרף עכשיו", // translated
  signIn: "להתחבר", // translated
  searchNow: "חפש כעת", // translated
  bookingFailed: "ההזמנה נכשלה", // translated
  sorryForTheInconvenience: "אנו מצטערים על אי הנוחות", // translated
  paymentFailedTryAgain: "התשלום נכשל. בבקשה נסה שוב", // translated
  quickLinks: "קישורים מהירים", // translated
  tours: "סיורים", // translated
  termsAndConditions: "תנאים", // translated
  pleaseWaitWhileInitiatingPayment: "אנא המתן בזמן שאנו מתחילים את תהליך התשלום שלך", // translated
  back: "חזור", // translated
  nextStep: "השלב הבא", // translated
  book: "סֵפֶר", // translated
  checkout: "לבדוק", // translated
  specifyPickUpPoint: "ציין את נקודת האיסוף המועדפת עליך", // translated
  pickupPoint: "נקודת איסוף", // translated
  optional: "אופציונאלי", // translated
  remarks: "הערות", // translated
  travellerInformation: "מידע למטייל", // translated
  bookingRemarks: "הערות הזמנה", // translated
  bookingOverview: "סקירת הזמנות", // translated
  paymentFailed: "התשלום נכשל", // translated
  paymentSuccess: "הצלחה בתשלום", // translated
  at: "בְּ", // translated
  person: "אדם", // translated
  cancellationPolicy: "מדיניות ביטול", // translated
  From: "מ", // translated // translated 
  to: "ל", // translated // translated 
  cancellationIs: "ביטול הוא", // translated
  pickup: "לאסוף", // translated
  flights: "טיסות", // translated
  Accommodation: "דִיוּר", // translated
  payAndBook: "שלם והזמן", // translated
  onRequest: "בבקשה", // translated
  weAreFindingTheBestAvailableServices: "אנו מוצאים את השירותים הטובים ביותר הזמינים", // translated
  withTheBestAvailablePrices: "עם המחירים הכי טובים שיש", // translated
  inRealTime: "בזמן אמת", // translated
  seconds: "שניות", // translated // translated 
  thisProcessCanTakeUpToOneMinute: "תהליך זה יכול להימשך עד דקה אחת", // translated
  pleaseDoNotRefreshThisPage: "נא לא לרענן את הדף הזה", // translated
  wellItSeemsItCanTakeBitLonger: "ובכן... נראה שזה יכול לקחת קצת יותר זמן", // translated
  yourBrowserDoesNotSupportTheVideoTag: "הדפדפן שלך אינו תומך בתג הווידאו", // translated
  bookingSuccess: "הצלחה בהזמנה", // translated
  bookingReference: "הפנייה להזמנה", // translated
  referenceCopied: "הפניה הועתקה", // translated
  shortlyYouReceiveEmailContainingInformationForYourReservation: "בקרוב תקבל אימייל המכיל את כל המידע הנדרש להזמנה שלך", // translated
  viewMore: "ראה עוד", // translated
  readMore: "קרא עוד", // translated
  customerSupport: "שירות לקוחות", // translated
  socialMedia: "מדיה חברתית", // translated
  hours: "שעה (ות", // translated
  hour: "שָׁעָה", // translated
  minutes: "דקות", // translated // translated 
  minute: "דַקָה", // translated
  memberId: "תעודת חבר", // translated
  star: "כוכב", // translated
  stars: "כוכבים", // translated
  proceed: "להמשיך", // translated
  clearAllFilters: "נקה את כל המסננים", // translated
  clearYourFilters: "נא לנקות את אפשרויות הסינון שלך כדי להציג תוצאות", // translated
  noOptionsForSelectedFilters: "אין אפשרויות זמינות להתאמת המסננים שלך", // translated
  privacyPolicy: "מדיניות הפרטיות", // translated
  security: "בִּטָחוֹן", // translated
  nearby: "סָמוּך", // translated
  distanceFromSelection: "מרחק מהבחירה", // translated
  km: "km", // translated
  restaurants: "מסעדות", // translated
  active: "פָּעִיל", // translated
  visitSite: "בקר באתר", // translated
  score: "ציון", // translated
  applicationAvailable: "אפליקציה זמינה", // translated
  sendUsEmail: "שלח לנו מייל", // translated
  sendUsYourRequest: "שלח לנו את בקשתך", // translated
  notAvailable: "לא זמין", // translated
  found: "מצאתי", // translated
  progressAt: "התקדמות ב", // translated
  currency: "מַטְבֵּעַ", // translated
  sendUsRequest: "שלח לנו את בקשתך", // translated
  noReservationsForThisProduct: "אין הזמנות למוצר זה", // translated
  confirmed: "מְאוּשָׁר", // translated
  cancelled: "מבוטל", // translated
  pending: "ממתין ל", // translated
  status: "סטָטוּס", // translated
  reference: "התייחסות", // translated
  leadGuest: "אורח מוביל", // translated
  sendVoucherEmail: "שלח אימייל שובר", // translated
  sendCancellationEmail: "שלח אימייל לביטול", // translated
  downloadVoucher: "הורד שובר", // translated
  emailHasBeenSent: "האימייל נשלח בהצלחה", // translated
  emailNotSentTryAgain: "מייל לא נשלח! בבקשה נסה שוב", // translated
  yourReservationIsInProgress: "ההזמנה שלך בעיצומה", // translated
  lastNameIsRequired: "נדרש שם משפחה", // translated
  invalidEmail: "אימייל שגוי", // translated
  firstNameIsRequired: "נדרש שם פרטי", // translated
  firstNameMustContainAlphabetic: "השם הפרטי חייב להכיל תווים אלפביתיים בלבד", // translated
  clickHere: "לחץ כאן", // translated
  countryIsRequired: "נדרשת מדינה", // translated
  cityIsRequired: "עיר נדרשת", // translated
  phoneNumberInTheFormat: "מספר הטלפון חייב להיות בפורמט ללא רווחים", // translated
  lastNameMustContainAlphabetic: "שם המשפחה חייב להכיל תווים אלפביתיים בלבד", // translated
  postalCodeIsRequired: "מיקוד נדרש", // translated
  iHaveReadAgreeWithAbove: "קראתי ואני מסכים עם האמור לעיל", // translated
  emailIsRequired: "נדרש אימייל", // translated
  genderIsRequired: "נדרש מגדר", // translated
  pleaseCheckTheBox: "אנא סמן את התיבה כדי לציין שקראת והסכמת למידע שסופק לפני שתמשיך לשלב הבא.", // translated
  titleIsRequired: "נדרשת כותרת", // translated
  phoneNumberIsRequired: "נדרש מספר טלפון", // translated
  addressIsRequired: "כתובת נדרשת", // translated
  maintenanceTitle: "האתר בתחזוקה", // translated 
  maintenanceDescription: "אנו מבצעים תחזוקה מתוכננת. אנא חזרו בקרוב.", // translated 
  maintenanceCountdownLabel: "זמן שנותר משורר", // translated 
  maintenanceLogoAlt: "לוגו האתר", // translated 
  maintenanceDays: "ימים", // translated 
  maintenanceHours: "שעות", // translated 
  maintenanceMinutes: "דקות", // translated 
  maintenanceSeconds: "שניות", // translated 
  maintenanceStatusBadge: "תחזקה מתוכננת", // translated 
  maintenanceRefresh: "רענן את הדף", // translated 
  maintenanceExpired: "התחזוקה אמורה להסתיים בקרוב. אנא רעננו את הדף.", // translated 
};


export default commonAndMisc;
